import { ClearOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import React from "react";
import { FileUploadsJobFilters } from "../../../../Interface";

const statusFilterOptions = [
  { label: "Pending", value: "pending" },
  { label: "Completed", value: "completed" },
  { label: "Failed", value: "failed" },
];

const sortFilterOptions = [
  { label: "Latest First", value: "latest_first" },
  { label: "Oldest First", value: "oldest_first" },
];

const failureReasonFilterOptions = [
  { label: "Application Limit Reached", value: "application.limit.reached" },
  { label: "Application Already Exists", value: "application.already.exists" },
  { label: "Failed to Extract User Details", value: "failed.to.extract.user.details" },
  { label: "Invalid File Format", value: "invalid.file.format" },
  { label: "Unable to Process Resume", value: "unable.to.process.resume" },
];

interface ActiveBulkUploadFilterMenuProps {
  handleFilterChange: (
    key: keyof FileUploadsJobFilters,
    value: string | null
  ) => void;
  filters: FileUploadsJobFilters;
  handleClearAll: () => void;
}

const ActiveBulkUploadFilterMenu: React.FC<ActiveBulkUploadFilterMenuProps> = ({
  handleFilterChange,
  filters,
  handleClearAll,
}) => {
  const handleStatusFilter = (value: string | undefined) => {
    handleFilterChange("status", value || null);
  }

  const handleFailureReasonFilter = (value: string | undefined) => {
    handleFilterChange("failureReason", value || null);
  }

  const handleSortFilter = (value: string | undefined) => {
    handleFilterChange("sort", value || null);
  }

  return (
    <div className="active-bulk-upload-filter-menu">
      <Select
        placeholder="Filter by Status"
        options={statusFilterOptions}
        size="middle"
        onChange={handleStatusFilter}
        value={filters.status}
        allowClear
      />

      <Select
        placeholder="Filter by Failure Reason"
        options={failureReasonFilterOptions}
        size="middle"
        onChange={handleFailureReasonFilter}
        value={filters.failureReason}
        allowClear
      />

      <Select
        placeholder="Sort by"
        options={sortFilterOptions}
        size="middle"
        onChange={handleSortFilter}
        value={filters.sort}
        allowClear
      />

      <Button
        type="default"
        size="middle"
        icon={<ClearOutlined />}
        onClick={handleClearAll}
      >
        Clear All
      </Button>
    </div>
  );
};

export default ActiveBulkUploadFilterMenu;
